import PageNotFoundView from '@components/errors/PageNotFoundView';

import copy from '@copy/Copy';

import { getSimpleLayout, PageLayout } from '@layouts/Layout';

const ErrorPageEmbedded: PageLayout = () => {
    return (
        <div className="flex h-screen w-full flex-col">
            <PageNotFoundView isIframe={true} />
        </div>
    );
};
ErrorPageEmbedded.getLayout = getSimpleLayout({
    className: 'fixed top-0 bottom-0 left-0 right-0 h-screen w-full',
    meta: {
        title: 'Not Found',
        description: copy.siteDescription,
        metaImageUrl: copy.siteMetaImageUrl,
        metaImageAltText: 'Pluto logo',
    },
});

export default ErrorPageEmbedded;
